import React from "react";
import { Container, Col, Form } from "react-bootstrap";
import { Producer } from "./producer";
import { Button } from "react-bootstrap";
import * as _ from "lodash"
import { PhoneRegex } from 'common/validation';
import AddProducerAccountPermissionModal from "./AddProducerAccountPermissionModal";
import { localizeProducer as localize } from "features/localization/localizeService";

export type AddProducerDetailsProps = {
  producer: Producer;
  handleNext: any;
  validated: boolean;
  handleCancel: any;
  showDeleteModal: any;
  showEditMode: boolean;
  hideDelete?: boolean;
  onProducerUpdated(producer: Producer): void;
};

const AddProducerDetails = (props: AddProducerDetailsProps) => (
  <Container>
    <Form noValidate validated={props.validated} onSubmit={props.handleNext}>
      <Form.Row>
      <Form.Group as={Col}>
        <Form.Label>{localize("AddProducerDetails_Label_FirstName")}</Form.Label>
        <Form.Control
          type="text"
          name="firstName"
          defaultValue={props.producer.firstName}
          onChange={(event: any) => props.onProducerUpdated({ ...props.producer, firstName: event.target.value?.trim() })}
          required={!props.producer.useBusinessName}
        ></Form.Control>
        <Form.Control.Feedback type="invalid">
          {localize("AddProducerDetails_Validation_FirstName")}
      </Form.Control.Feedback>
      </Form.Group>
    
      <Form.Group as={Col}>
        <Form.Label>{localize("AddProducerDetails_Label_LastName")}</Form.Label>
        <Form.Control
          type="text"
          name="lastname"
          defaultValue={props.producer.lastName}
          onChange={(event: any) => props.onProducerUpdated({ ...props.producer, lastName: event.target.value?.trim() })}
          required={!props.producer.useBusinessName}
        ></Form.Control>
        <Form.Control.Feedback type="invalid">
          {localize("AddProducerDetails_Validation_LastName")}
        </Form.Control.Feedback>
      </Form.Group>
   </Form.Row>

      <Form.Row>
      <Form.Group as={Col}>
        <Form.Label>{localize("AddProducerDetails_Label_BusinessName")}</Form.Label>
        <Form.Control
          type="text"
          name="businessName"
          defaultValue={props.producer.businessName}
          onChange={(event: any) => props.onProducerUpdated({ ...props.producer, businessName: event.target.value?.trim() })}
          required={props.producer.useBusinessName}
        ></Form.Control>
        <Form.Control.Feedback type="invalid">
          {localize("AddProducerDetails_Validation_BusinessName")}
      </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col}>
          <Form.Check custom
              id="useBusinessName">
            <Form.Check.Input defaultChecked={props.producer.useBusinessName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.onProducerUpdated({ ...props.producer, useBusinessName: event.target.checked })} />
            <Form.Check.Label className="text-dark">{localize("AddProducerDetails_Label_BusinessNameAsCustomerName")}</Form.Check.Label>
          </Form.Check>
        </Form.Group>
      </Form.Row>

      <Form.Row>
      <Form.Group as={Col}>
        <Form.Label className="optional">{localize("AddProducerDetails_Label_Email")}</Form.Label>
        <Form.Control
          type="email"
          name="email"
          defaultValue={props.producer.email}
            onChange={(event: any) => props.onProducerUpdated({ ...props.producer, email: event.target.value?.trim() })}
        ></Form.Control>
        <Form.Control.Feedback type="invalid">
          {localize("AddProducerDetails_Validation_Email")}
        </Form.Control.Feedback>
        </Form.Group>
      </Form.Row>
    
      <Form.Row>
      <Form.Group as={Col}>
        <Form.Label className="optional">{localize("AddProducerDetails_Label_Phone")}</Form.Label>
        <Form.Control
          type="text"
          name="phone"
          pattern={PhoneRegex.source}
          defaultValue={props.producer.phone}
            onChange={(event: any) => props.onProducerUpdated({ ...props.producer, phone: event.target.value?.trim() })}
        ></Form.Control>
        <Form.Control.Feedback type="invalid">
          {localize("AddProducerDetails_Validation_Phone")}
        </Form.Control.Feedback>
    </Form.Group>
    <Form.Group as={Col}>
      <Form.Label className="optional">{localize("AddProducerDetails_Label_Zip")}</Form.Label>
      <Form.Control
        type="text"
        name="zipCode"
        defaultValue={props.producer.postalCode}
            onChange={(event: any) => props.onProducerUpdated({ ...props.producer, postalCode: event.target.value?.trim() })}
      ></Form.Control> 
      </Form.Group>
    </Form.Row>

    <Form.Row>
      <Form.Group as={Col}>
      <Form.Label className="optional">{localize("AddProducerDetails_Label_Accounts")}</Form.Label>
          <AddProducerAccountPermissionModal 
            producerAccounts={props.producer.accounts}
            onAccountsChanged={(accounts) => props.onProducerUpdated({...props.producer, accounts: accounts})}
            />
      </Form.Group>
    </Form.Row>

    <div className="row">
    <div className="col-4">
      {props.showEditMode && !props.hideDelete && (
        <div className="pull-left mt-5" onClick={props.showDeleteModal}>
          <span style={{ fontSize: 'x-large' }}  className="fa fa-trash" />
        </div>
      )}
      
    </div>
    <div className="col-8">
      <div className="pull-right mt-5">
        <Button variant="secondary" className="ml-2" onClick={props.handleCancel}>
          {localize("AddProducerDetails_Button_Cancel")}
        </Button>{" "}
        <Button variant="primary" type="submit">
          {localize("AddProducerDetails_Button_Next")}
        </Button>
      </div>
    </div>
  </div>
    </Form>
  </Container>
);

export default AddProducerDetails;
